import { alert } from '../../../components/Alert/tokens/cobalt';
import { backDrop } from '../../../components/BackDrop/tokens/cobalt';
import { badge } from '../../../components/Badge/tokens/cobalt';
import { button } from '../../../components/Button/tokens/cobalt';
import { card } from '../../../components/Card/tokens/cobalt';
import { coupon } from '../../../components/Coupon/tokens/cobalt';
import { input } from '../../../components/Input/tokens/cobalt';
import { link } from '../../../components/Link/tokens/cobalt';
import { modal } from '../../../components/Modal/tokens/cobalt';
import { popup } from '../../../components/Popup/tokens/cobalt';
import { radioButton } from '../../../components/RadioButton/tokens/cobalt';
import { switchTokens } from '../../../components/Switch/tokens/cobalt';
import { link as deprecatedLink } from '../../../deprecated/Link/tokens/cobalt';
import { deprecatedModal } from '../../../deprecated/Modal/tokens/cobalt';
import { body } from '../../../typography/Body/tokens/cobalt';
import { display } from '../../../typography/Display/tokens/cobalt';
import { heading } from '../../../typography/Heading/tokens/cobalt';
import type { BaseComponentTokens } from '../types';
import { money } from '../../../components/Money/tokens/cobalt';

export const baseComponents: BaseComponentTokens = {
  alert,
  badge,
  backDrop,
  body,
  button,
  card,
  deprecatedLink,
  deprecatedModal,
  display,
  heading,
  input,
  link,
  modal,
  money,
  popup,
  radioButton,
  coupon,
  switch: switchTokens,
};
